import React from "react";
import { Link } from "react-router-dom";
import HeroSection from "../Elements/Herosection";
import About from './img/DoctorP.webp'
import { Row, Col, Container } from "react-bootstrap";
import VisionImage from './img/drservices.avif'
import "aos/dist/aos.css";
import Slider from "react-slick";
import CountUp from 'react-countup';
import { Carousel } from 'react-bootstrap';
import hero1 from './img/swatiDr.jpg'
import hero2 from './img/1.jpg'
import hero3 from './img/3.jpg'
import { Helmet } from 'react-helmet';
import { useEffect } from "react";
import    AOS  from "aos";
import Social_work from '../Elements/pictures'
const testimonials = [

  {
    id: 1,
    name: "Adult Psychaitric Cases",
    text: "Adult psychiatric cases refer to mental health conditions or disorders that affect individuals during adulthood. These conditions can impact a person thoughts.",
    role: "Read More",
  },
  {
    id: 2,
    text: "Psychotherapy and counseling are both forms of talking therapies that aim to help individuals address emotional and behavioral challenges.",
    name: "Psychotherapy and Counseling",
    role: "Read More",
  },
  {
    id: 3,
    text: "Behavioral Therapy is a type of psychotherapy that focuses on modifying or changing harmful or maladaptive behaviors. ",
    name: "Behavorial Therapy",
    role: "Read More",
  },
  {
    id: 4,
    text: "Child Guidance refers to the process of helping children develop appropriate behaviors and social skills through various strategies and interventions.",
    name: "Child Guidance",
    role: "Read More",
  },
  {
    id: 5,
    text: "IQ Testing and Aptitude Testing are both types of assessments designed to measure different aspects of an individual’s cognitive abilities.",
    name: "IQ Testing and Aptitude Testing",
    role: "Read More",
  },
  {
    id: 6,
    text: "Career Counseling is a process in which a trained professional help understand their strengths, interests to guide them in making informed career decisions",
    name: "Career Counseling",
    role: "Read More",
  },
  {
    id: 7,
    text: "Psychometric Evaluation is the use of scientifically designed tests to assess an individual's cognitive abilities, mental health, skills, and motivations.",
    name: "Psychometric Evaluation",
    role: "Read More",
  },
  {
    id: 8,
    text: "Sexual dysfunction refers to difficulties a person may experience during any phase of the sexual response .",
    name: "Treatement for sexual dysfunction",
    role: "Read More",
  },
  {
    id: 9,
    text: "Marital therapy, also known as couples therapy , is a type of psychotherapy that helps couples resolve issues affecting their relationship.",
    name: "Marital Therapy",
    role: "Read More",
  },
  {
    id: 10,
    text: "Group therapy involves a therapist-guided session where individuals meet together and setting to discuss and address their emotional, psychological issues ",
    name: "Group Therapy",
    role: "Read More",
  },
];
const Home = () => {
  const settings = {
    dots: true, 
    infinite: true, 
    speed: 2000, 
    slidesToShow: 3, 
    slidesToScroll: 1, 
    autoplay: true, 
    autoplaySpeed: 2000,

    responsive: [
      {
        breakpoint: 1024, 
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768, 
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  useEffect(() => {

    AOS.init({ duration: 1500, easing: 'ease-in-out', once: true });
  }, []); 
  const coun = [
    {
      counter: 50000,
      ext: "Happy Patients",
      txt: "Helping individuals achieve mental well-being",
      icon: "fa-solid fa-smile-beam"
    },
    {
      counter: 400,
      ext: "Therapy Sessions",
      txt: "Providing personalized therapy for various conditions",
      icon: "fa-solid fa-chalkboard-teacher"
    },
    {
      counter: 10,
      ext: "Year of Experience",
      txt: "we specialize in understanding and addressing the unique mental health.",
      icon: "fas fa-clock"
    },
    {
      counter: 5,
      ext: "Dedicated Staff",
      txt: "Team of expert professionals working with care and dedication",
      icon: "fa-solid fa-users"
    },
  ];

  return (
    
    <div>
        <Helmet>
        <title>Psychiatric Care - Your Mental Health Matters</title>
        <meta name="google-site-verification" content="hDy2TyO5-XOsY-kqHa_AsfhwAKrzVrvGjXLKbQkdVlw" />
        <meta name="description" content="We provide expert psychiatric care and mental health services to help you lead a happier, healthier life. Explore our treatments and therapies." />
      </Helmet>
  
      <div>
      <Carousel interval={5000} className="position-relative">
        <Carousel.Item>
        <img
          className="d-block w-100 carousel-image"
          src={hero1}
          alt="First slide"
        />
          <Carousel.Caption className="">
          <HeroSection
          title="Welcome to Our Hospital"
          description="We offer the best medical services for your health and wellness."
          buttonText="See More"
          buttonLink="/About"    
        /> 
        
 </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src={hero2}
            alt="Second slide"
          />
          <Carousel.Caption className="carousel-caption animate-text">
          <HeroSection
          title="Mental Health Matters"
          description="We understand and guide you every step."
          buttonText="See More"
          buttonLink="/About" 
        /> 
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src={hero3}
            alt="Third slide"
          />
          <Carousel.Caption className="carousel-caption animate-text">
          <HeroSection
          title="Start Your Journey"
          description="Carefully managed prescriptions to support your mental wellness."  
          buttonText="See More"
          buttonLink="/About"  
        /> 
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </div>


        {/* Passing dynamic content and image to the HeroSection component */}
        {/* <HeroSection
          title="Welcome to Our Hospital"
          description="We offer the best medical services for your health and wellness."
          buttonText="Contact Us"
          buttonLink="/contact"
          imageSrc={Dr}
        /> */}
  
      {/* About Vision*/}


      <div className="py-5 bg-gray-100">
        <Container>
          <Row className="align-items-center">
            {/* Mission Text Section */}
            <Col md={6} className="mb-4" data-aos="fade-right">
              <h2 className="text-4xl font-bold text-blue-900 mb-3">
                Feel Stronger, Healthier, and Happier with Our Expert Care
              </h2>
              <p className="text-lg text-gray-700 mb-4">
                we are dedicated to helping you feel stronger, healthier, and happier through personalized, professional care. Our team of expert therapists and counselors offers a range of services designed to support individuals, couples, and families in overcoming life's challenges and achieving lasting emotional well-being.
              </p>

              <Link to="/about">
              <button
                      className="group relative rounded-lg px-6 py-3 font-bold text-black"
                      onClick={() => window.location.href = "tel:9607899660"}
                    >
                <span className="ease absolute inset-0 h-full w-full -translate-x-1 -translate-y-1 transform bg-blue-900 transition duration-300 group-hover:translate-x-0 group-hover:translate-y-0"></span>
                  <span className="ease absolute inset-0 h-full w-full translate-x-1 translate-y-1 transform bg-cyan-500 mix-blend-screen transition duration-300 group-hover:translate-x-0 group-hover:translate-y-0"></span>
                  <span className="relative">Book Appoinment</span>
                </button>
              </Link>
            </Col>

            {/* Mission Image Section */}
            <Col md={6} className="text-center" data-aos="fade-left">
              <img
                src={About}
                alt="Hospital"
                className="img-fluid rounded  transition-all duration-500 ease-in-out hover:scale-105 hover:rotate-2 hover:opacity-90"
              />
              
            </Col>

          </Row>
        </Container>
      </div>

      {/* About Vision */}
      <div className="py-5 bg-white">
        <Container>
          <Row className="align-items-center">
            {/* Vision Image Section */}
            <Col md={6} className="text-center mb-4 " data-aos="fade-right">
              <img
                src={VisionImage}
                alt="Vision"
                className="img-fluid rounded-md shadow-lg hover:scale-105 transform transition duration-500 ease-in-out"
              />
            </Col>

            {/* Vision Text Section */}
            <Col md={6} data-aos="fade-left">
              <h2 className="text-4xl font-bold text-blue-900 mb-3">
                Feel Better with Our Services
              </h2>
              <p className="text-lg text-gray-700 mb-4">
                We are dedicated to supporting your mental and emotional well-being through a wide range of professional services tailored to meet your needs. Whether you're struggling with stress, anxiety, relationship issues, or personal growth, our expert team is here to help you feel better, regain balance, and achieve a healthier, happier life.
              </p>
              <Link to="/Treatment">
                <button className="group relative rounded-lg px-6 py-3 font-bold text-black">
                  <span className="ease absolute inset-0 h-full w-full -translate-x-1 -translate-y-1 transform bg-blue-900 transition duration-300 group-hover:translate-x-0 group-hover:translate-y-0"></span>
                  <span className="ease absolute inset-0 h-full w-full translate-x-1 translate-y-1 transform bg-cyan-500 mix-blend-screen transition duration-300 group-hover:translate-x-0 group-hover:translate-y-0"></span>
                  <span className="relative">Learn more</span>
                </button>
              </Link>
            </Col>
          </Row>
        </Container>
      </div>
      <div className=" mb-5 shadow-lg " style={{backgroundColor:'#13baab'
      }}>  
<Container>
  <Row>
    {coun.map((b, index) => {
      return (
        <Col
          lg={3}
          md={6}
          sm={12}
          className="mt-5 mb-5 p-2 vertical-line"
          key={index}
        >
          <div
            className="d-flex align-items-center"
         
          >
            <div className="me-3"></div>
            <span className="counter-wrapper">
              <h2>
                <CountUp
                  start={0}
                  end={b.counter}
                  duration={2}
                  suffix="+" 
                />
              </h2>
              <b>{b.ext}</b>
            </span>
          </div>
        </Col>
      );
    })}
  </Row>
</Container>


      </div>

<Social_work/>
      {/* Call to Action Section */}

      <div className="cta mb-5" >
        <div className="container py-5 d-flex flex-column align-items-center text-center">
          <h4 className="font-bold text-2xl mb-3">
            "Caring for Your Mind, Body, and Soul"
          </h4>
          <h3 className="text-muted text-lg px-3" style={{ maxWidth: "800px", lineHeight: "1.6" }}>
            At the heart of our practice lies a commitment to mental wellness and emotional healing.
            Our experienced psychiatric doctor specializes in understanding the complexities of the human mind,
            offering personalized care for conditions such as anxiety, depression, mood disorders, and more.
            With a compassionate approach and the latest evidence-based treatments, we strive to empower
            individuals on their journey toward a healthier and happier life. Your mental health is our priority,
            and we are here to guide you every step of the way.
          </h3>    
        </div>
      </div>
      

      {/* Testimonials Section */}
      <div className="container py-5 p-2">
        <h2 className="text-black text-center font-bold text-4xl mb-5">
          Services Available
        </h2>
        <Slider {...settings}>
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="px-3 mb-5">
              <div className="card shadow-sm border-0">
                <div className="card-body">
                  <h5 className="text-info-emphasis font-bold">{testimonial.name}</h5>
                  <p className="card-text text-muted">"{testimonial.text}"</p>
                  <Link to="/Treatment">
                    <button className="group relative inline-flex items-center justify-center overflow-hidden rounded-lg bg-blue-600 px-10 py-2 font-mono font-medium tracking-tighter text-white">
                    <span className="absolute h-0 w-0 rounded-full bg-cyan-300 transition-all duration-500 ease-out group-hover:h-56 group-hover:w-56"></span>
                      <span className="absolute inset-0 -mt-0 h-full w-full rounded-lg bg-gradient-to-b from-transparent to-gray-700"></span>
                      <span className="relative">{testimonial.role}</span>
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>

    
    </div>
  );
};

export default Home;
